import VueMonthlyPicker from 'vue-monthly-picker';
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
import LineChart from './Types/Am/Line';
import ColumnChart from './Types/Apex/Column';
import CarpetChart from './Types/Apex/Carpet';
import PieChart from './Types/Apex/Pie';
import PieAmChart from './Types/Am/Pie';
import CarpetAmChart from './Types/Am/Carpet';
import ScatterAmChart from './Types/Am/Scatter';
import RadarChart from './Types/Apex/Radar';
import RadarAmChart from './Types/Am/Radar';
import Slots from './Types/Apex/Slots';
import SlotsAm from './Types/Am/Slots';
import Actions from './Actions';
import moment from 'moment';
import { mapState, mapGetters, mapActions } from 'vuex';
import { samplings as samplingValues, getSamplings, getMinSampling, getDisabledByMin } from "@/helpers/measure";
import VueCookie from 'vue-cookie';

const LONG_DATE_FORMAT = 'DD/MM/YYYY';
const SHORT_DATE_FORMAT = 'MM/YYYY';
const YEAR_DATE_FORMAT = 'YYYY';

export default {
  components: {
    LineChart,
    ColumnChart,
    CarpetChart,
    PieChart,
    RadarChart,
    VueMonthlyPicker,
    DatePick,
    Actions,
    Slots,
    SlotsAm,
    RadarAmChart,
    PieAmChart,
    CarpetAmChart,
    ScatterAmChart
  },

  data() {
    return {
      sampling: 'd',
      fromYear: null,
      toYear: null,
      fromMonth: null,
      toMonth: null,
      fromDate: null,
      split: false,
      toDate: null,
      current: 'line',
      channels: [],
      parameters: [],
      imageUri: null,
      rebuildTimer: null,
      delay: 0,
      compare: "no",
      showCompareSelector: true,
      compareFromYear: moment(),
      compareFromMonth: moment(),
      compareFromDate: moment().format(LONG_DATE_FORMAT),
      maxMonth: moment(),
      isNeedUpdate: false,
      samplingValues: getSamplings(),
      filterSettings: null
    };
  },

  beforeMount() {
    this.filterSelectedSourcesForMode(this.mode === "INDICATORS" ? ["indicator"] : ["channel", "parameter"])
  },

  async mounted() {    
    // loading measure types
    if (this.$store.state.charts.measureTypes.length === 0) await this.loadMeasureTypes()

    //setting respective values from chart if it was recieved as prop
    if (this.reportMode) return this.setChart(this.reportSection)

    // setting channels and parameters from 'selectedSources' list in vuex store [charts module]
    this.channels = this.selectedSources.filter(ss => ss.type === (this.mode === "INDICATORS" ? "indicator" : "channel")).map(ss => ss.code);
    this.parameters = this.selectedSources.filter(ss => ss.type === "parameter").map(ss => ss.code);

    // making necessary changes for carpet chart
    if (this.current == 'carpet') {
      this.samplingValues = [
        { text: "15 minuti", value: '15' },
        { text: "60 minuti", value: '60' }
      ];
    }

    // setting dates and sampling type
    let cookieValue;//temporary holder for cookie value to enable efficient comparisons
    this.compare = VueCookie.get(`${this.$store.state.user.databaseName}.${this.mode}.compare`) || this.compare;
    this.sampling = VueCookie.get(`${this.$store.state.user.databaseName}.${this.mode}.sampling`) || this.stateSampling;
    if (this.sampling === 'y') {
      cookieValue = VueCookie.get(`${this.$store.state.user.databaseName}.${this.mode}.toYear`)
      this.toYear = cookieValue ? moment(cookieValue, YEAR_DATE_FORMAT) : moment().format(YEAR_DATE_FORMAT);
      cookieValue = VueCookie.get(`${this.$store.state.user.databaseName}.${this.mode}.fromYear`)
      this.fromYear = cookieValue ? moment(cookieValue, YEAR_DATE_FORMAT) : moment().subtract(1, 'y').format(YEAR_DATE_FORMAT);
    } else if (this.sampling === 'm') {
      cookieValue = VueCookie.get(`${this.$store.state.user.databaseName}.${this.mode}.toMonth`)
      this.toMonth = cookieValue ? moment(cookieValue, SHORT_DATE_FORMAT) : moment().subtract(1, 'M');
      cookieValue = VueCookie.get(`${this.$store.state.user.databaseName}.${this.mode}.fromMonth`)
      this.fromMonth = cookieValue ? moment(cookieValue, SHORT_DATE_FORMAT) : moment().subtract(1, 'y').subtract(1, 'M');
    } else {
      this.toDate = VueCookie.get(`${this.$store.state.user.databaseName}.${this.mode}.toDate`) || moment().format(LONG_DATE_FORMAT);
      this.fromDate = VueCookie.get(`${this.$store.state.user.databaseName}.${this.mode}.fromDate`) || moment().subtract(1, 'M').format(LONG_DATE_FORMAT);
    }
  },

  watch: {
    filter() {
      let channelSamplingMin = 100;
      let number = 0;

      if(this.filter.mode == "INDICATORS") {
        return;
      }

      if(this.filter.channels.length > 0 || this.filter.parameters.length > 0) {
        this.channels = this.filter.channels;
        this.parameters = this.filter.parameters;
        this.samplingValues.forEach(item => item.disabled = false);
        
        for(let i = 0; i < this.$store.state.user.sites.length; i++) {
          for(let j = 0; j < this.$store.state.user.sites[i].channels.length; j++) {
            this.channels.forEach(item => {
              if(item == this.$store.state.user.sites[i].channels[j].code) {
                if(this.$store.state.user.sites[i].channels[j].min_sampling == 'd') {
                  number = 61; 
                } else if(this.$store.state.user.sites[i].channels[j].min_sampling == 'm') {
                  number = 62; 
                } else if(this.$store.state.user.sites[i].channels[j].min_sampling == 'y') {
                  number = 63; 
                } else {
                  number = Number(this.$store.state.user.sites[i].channels[j].min_sampling);
                }
                if(number < channelSamplingMin ) {
                  channelSamplingMin = number
                }
              }
            });
          }
          
          for(let k = 0; k < this.$store.state.user.sites[i].parameters.length; k++) {
            this.parameters.forEach(item => {
              if(item == this.$store.state.user.sites[i].parameters[k].code) {
                if(this.$store.state.user.sites[i].parameters[k].min_sampling == 'd') {
                  number = 61; 
                } else if(this.$store.state.user.sites[i].parameters[k].min_sampling == 'm') {
                  number = 62; 
                } else if(this.$store.state.user.sites[i].parameters[k].min_sampling == 'y') {
                  number = 63; 
                } else {
                  number = Number(this.$store.state.user.sites[i].parameters[k].min_sampling);
                }
                if(number < channelSamplingMin ) {
                  channelSamplingMin = number
                }
              }
            });
          }
        }
        this.samplingValues.forEach(item => {
          if(item.value == 'd') {
            item.number = 61;
          } else if(item.value == 'm') {
            item.number = 62;
          } else if(item.value == 'y') {
            item.number = 63;
          } else {
            item.number = Number(item.value);
          }

          if(this.current == "slots" && item.number < 61) {
            item.disabled = true;
          }
          
          if(item.number < channelSamplingMin) {
            item.disabled = true;
          }
        }); 
        let samplingCopy = this.sampling;
        if(samplingCopy == 'y') {
          samplingCopy = 63;
        } else if(samplingCopy == 'm') {
          samplingCopy = 62;
        } else if(samplingCopy == 'd') {
          samplingCopy = 61;
        } else {
          samplingCopy = Number(samplingCopy);
        }

        if(channelSamplingMin > samplingCopy) {
          if(channelSamplingMin == 63) {
            this.sampling = 'y';
          } else if(channelSamplingMin == 62) {
            this.sampling = 'm';
          } else if(channelSamplingMin == 61) {
            this.sampling = 'd';
          } else {
            this.sampling = channelSamplingMin.toString();
          } 
        }
      }
      
    },

    selectedSources: {
      deep: true,
      handler(val) {
        this.isNeedUpdate = true;
        this.checkSampling();
        if (!this.reportMode && !!this.stateTree) {
          VueCookie.set(`${this.$store.state.user.databaseName}.${this.mode}.selectedNodes`, JSON.stringify(this.selectedSources))
        }
      },
    },

    stateTree: {
      deep: true,
      handler() {
        if (!this.reportMode && !!this.stateTree) {
          VueCookie.set(`${this.$store.state.user.databaseName}.${this.mode}.expandedNodes`, JSON.stringify(this.getExpandedNodes))
        }
      }
    },
    sampling(newValue, oldValue) {
      const fromDateFormat = this.getDateFormatFromDateString(this.fromDate);
      const toDateFormat = this.getDateFormatFromDateString(this.toDate);

      this.$store.dispatch("session/setSampling", newValue);
      if (!this.reportMode) VueCookie.set(`${this.$store.state.user.databaseName}.${this.mode}.sampling`, newValue)
      if (newValue === "m" && (this.fromDate && this.toDate)) {
        this.fromMonth = moment(this.fromDate, fromDateFormat, true);
        this.toMonth = moment(this.toDate, toDateFormat, true);
      }

      if (newValue === "y" && (this.fromDate && this.toDate)) {
        this.fromYear = moment(this.fromDate, fromDateFormat, true);
        this.toYear = moment(this.toDate, toDateFormat, true);
      }

      if (newValue === "w") {
        const from = moment(this.fromDate, fromDateFormat, true);
        if (from.day() !== 1) {
          this.fromDate = from.startOf('week').format(LONG_DATE_FORMAT);
        }

        const to = moment(this.toDate, toDateFormat, true);
        if (to.day() !== 1) {
          this.toDate = to.startOf('week').format(LONG_DATE_FORMAT);
        }
      }

      if (oldValue === "m") {
        this.fromDate = moment(this.fromMonth).format(LONG_DATE_FORMAT);
        this.toDate = moment(this.toMonth).format(LONG_DATE_FORMAT);
      }

      if (oldValue === "y") {
        this.fromDate = moment(this.fromYear).format(LONG_DATE_FORMAT);
        this.toDate = moment(this.toYear).format(LONG_DATE_FORMAT);
      }
    },

    fromDate(v) {
      if (!v) return
      const fromDateFormat = this.getDateFormatFromDateString(v);
      const toDateFormat = this.getDateFormatFromDateString(this.toDate);

      this.$store.dispatch("session/setChartFromDate", v);
      if (!this.reportMode) VueCookie.set(`${this.$store.state.user.databaseName}.${this.mode}.fromDate`, v)

      let from = moment(v, fromDateFormat, true);
      let to = moment(this.toDate, toDateFormat, true);

      if (from.isAfter(to)) {
        this.toDate = from.add(1, 'months').format(LONG_DATE_FORMAT);
      }

      if (this.compare !== "custom") {
        this.compareFromDate = from.add(-1, 'months').format(LONG_DATE_FORMAT);
      }
    },

    toDate(v) {
      if (!v) return
      this.$store.dispatch("session/setChartToDate", v);
      if (!this.reportMode) VueCookie.set(`${this.$store.state.user.databaseName}.${this.mode}.toDate`, v)

      const fromDateFormat = this.getDateFormatFromDateString(this.fromDate);
      const toDateFormat = this.getDateFormatFromDateString(v);

      let from = moment(this.fromDate, fromDateFormat, true);
      let to = moment(v, toDateFormat, true);

      if (to.isBefore(from)) {
        this.fromDate = to.subtract(1, 'months').format(LONG_DATE_FORMAT);
      }
    },

    fromMonth(v) {
      const fromDateFormat = this.getDateFormatFromDateString(moment(v).format(SHORT_DATE_FORMAT));
      const m = moment(v, fromDateFormat, true);
      if (m.isValid()) {
        this.$store.dispatch("session/setChartFromMonth", moment(v).format(SHORT_DATE_FORMAT));
        if (!this.reportMode) VueCookie.set(`${this.$store.state.user.databaseName}.${this.mode}.fromMonth`, moment(v).format(SHORT_DATE_FORMAT))
      }

      if (this.compare !== "custom") {
        this.compareFromMonth = m.add(-1, 'months');
      }
    },

    toMonth(v) {
      const fromDateFormat = this.getDateFormatFromDateString(moment(v).format(SHORT_DATE_FORMAT));
      const m = moment(v, fromDateFormat, true);
      if (m.isValid()) {
        this.$store.dispatch("session/setChartToMonth", moment(v).format(SHORT_DATE_FORMAT));
        if (!this.reportMode) VueCookie.set(`${this.$store.state.user.databaseName}.${this.mode}.toMonth`, moment(v).format(SHORT_DATE_FORMAT))
      }
    },

    fromYear(v) {
      const fromDateFormat = this.getDateFormatFromDateString(moment(v).format(YEAR_DATE_FORMAT));
      const y = moment(v, fromDateFormat, true);
      if (y.isValid()) {
        this.$store.dispatch("session/setChartFromYear", moment(v).format(YEAR_DATE_FORMAT));
        if (!this.reportMode) 
          VueCookie.set(`${this.$store.state.user.databaseName}.${this.mode}.fromYear`, moment(v).format(YEAR_DATE_FORMAT))
      }

      if (this.compare !== "custom") {
        this.compareFromYear = y.add(-1, 'years');
      }
    },

    toYear(v) {
      const fromDateFormat = this.getDateFormatFromDateString(moment(v).format(YEAR_DATE_FORMAT));
      const y = moment(v, fromDateFormat, true);
      if (y.isValid()) {
        this.$store.dispatch("session/setChartToYear", moment(v).format(YEAR_DATE_FORMAT));
        if (!this.reportMode) VueCookie.set(`${this.$store.state.user.databaseName}.${this.mode}.toYear`, moment(v).format(YEAR_DATE_FORMAT))
      }
    },

    charts() {
      if (this.$route.params.id) {
        let chart = this.charts.find(c => c.userChartId == this.$route.params.id);
        
        if (chart) {
          this.sampling = chart.sampling;
          this.fromDate = chart.fromDate;
          this.toDate = chart.toDate;
          this.fromMonth = chart.fromMonth;
          this.toMonth = chart.toMonth;
          this.compare = chart.compare;
          this.filter.channels = chart.channels;
          this.filter.fromMonth = this.fromMonth;
          this.filter.toMonth = this.toMonth;
          this.filter.parameters = chart.parameters;
        }
      }

    },

    current(newChartType, oldChartType) {
      const maxDaysForCarpet = 7;

      const isMinutesSampling = ['1', '15', '60'].includes(this.sampling);
      if (oldChartType === 'carpet' && isMinutesSampling) {
        this.sampling = 'd';
      }

      if (newChartType === 'carpet') {
        if (!isMinutesSampling) {
          this.sampling = '1';

          // Check date range
          const fromDateFormat = this.getDateFormatFromDateString(this.fromDate);
          const toDateFormat = this.getDateFormatFromDateString(this.toDate);
          let from = moment(this.fromDate, fromDateFormat, true);
          let to = moment(this.toDate, toDateFormat, true);

          if (to.diff(from, 'days') > maxDaysForCarpet) {
            this.fromDate = to.subtract(maxDaysForCarpet, 'days').format(fromDateFormat);
          }
        }
      }
    },
    compare(v) {
      if (!this.reportMode) ('charts.compare', v)
    }
  },

  computed: {
    filter() {
      let filters = {
        channels: this.selectedSources.filter(s => s.type === this.mode === "INDICATORS" ? 'indicator' : "channel").map(s => s.code),
        parameters: this.selectedSources.filter(s => s.type === "parameter").map(s => s.code),
        sampling: this.sampling,
        split: this.split,
        mode: this.mode,
        sources: []
      };

      //populating sources in filters
      this.selectedSources.filter(s => s.type === "channel").forEach(s => {
        //if no measures, just push one source into 'filters.sources' list with measureType 'null'
        if (!s.measures) {
          return filters.sources.push({
            sourceCode: s.code,
            sourceType: s.type.toUpperCase(),
            measureType: null,
            dataModelId: s.dataModelId,
          })
        }
        //if measures, for each measure, push into 'filters.sources' with respective measureType
        s.measures.forEach(m => {
          filters.sources.push({
            sourceCode: s.code,
            sourceType: s.type.toUpperCase(),
            measureType: m,
            dataModelId: s.dataModelId,
          })
        })
      })

      //if parameters, for each parameter, push into 'filters.sources' with respective measureType
      filters.parameters.forEach((parameter) => {
        filters.sources.push({
          sourceCode: parameter,
          sourceType: 'PARAMETER',
          measureType: null,
        });
      });

      if (this.current === 'line' || this.current === 'column') {
        filters.compare = this.compare;

        if (this.compare !== "no") {
          const compareDateFormat = this.getDateFormatFromDateString(this.compareFromDate);
          if (this.sampling === 'y')
            filters.compareFromYear = moment(this.compareFromYear).format("YYYY");
          else if (this.sampling === 'm')
            filters.compareFromMonth = moment(this.compareFromMonth).format("M-YYYY");
          else
            filters.compareFromDate = moment(this.compareFromDate, compareDateFormat).format("YYYY-MM-DD");
        }
      }

      if (['1', '15', '60', 'd', 'w'].includes(this.sampling)) {
        const fromDateDateFormat = this.getDateFormatFromDateString(this.fromDate);
        const toDateDateFormat = this.getDateFormatFromDateString(this.toDate);
        filters.fromDate = moment(this.fromDate, fromDateDateFormat).format("YYYY-MM-DD");
        filters.toDate = moment(this.toDate, toDateDateFormat).format("YYYY-MM-DD");
      }

      if (this.sampling === 'm' && this.fromMonth != null) {
        filters.fromMonth = moment(this.fromMonth).format("M-YYYY");
        filters.toMonth = moment(this.toMonth).format("M-YYYY");
      }

      if (this.sampling === 'y' && this.fromYear != null) {
        filters.fromYear = moment(this.fromYear).format(YEAR_DATE_FORMAT);
        filters.toYear = moment(this.toYear).format(YEAR_DATE_FORMAT);
      }

      return filters;
    },

    ...mapState({
      sites: state => state.user.sites,
      stateTree: state => state.charts.tree,
      selectedSources: state => state.charts.selectedSources,
      selectedMeasureTypes: state => state.charts.selectedMeasureTypes,
    }),

    ...mapGetters({
      stateChartFromDate: "session/chartFromDate",
      stateChartFromMonth: "session/chartFromMonth",
      stateChartToDate: "session/chartToDate",
      stateChartToMonth: "session/chartToMonth",
      stateSampling: "session/sampling",
      getStoreMinSampling: "charts/getMinSampling",
      getNodeByCode: 'charts/getNodeByCode',
      getExpandedNodes: 'charts/getExpandedNodes',
    }),

    currentYear() {
      return parseInt(moment().format("YYYY"));
    },

    showCompare() {
      return (this.current === 'line' || this.current === 'column') && this.showCompareSelector && this.sampling != 'y';
    },

    charts() {
      return this.$store.state.user && this.$store.state.user.charts ?
        this.$store.state.user.charts.filter(c => !c.dashboard) : [];
    },

    showWarning() {
      return this.selectedSources.length === 0;
    },

    monthLabels() {
      return 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_');
    },
    monthsNames() {
      return this.$store.state.utils.months;
    },
    daysNames() {
      return this.$store.state.utils.daysShort;
    },
    monthsRange() {
      return [this.selectedMonth.format("M-YYYY")];
    },
    monthFrom() {
      return this.selectedMonth.format("M-YYYY");
    },
  },

  methods: {
    ...mapActions({
      loadMeasureTypes: 'charts/loadMeasureTypes',
      toggleSelectState: 'charts/toggleSelectState',
      removeSource: 'charts/removeSource',
      filterSelectedSourcesForMode: 'charts/filterSelectedSourcesForMode',
      clearAllSelectedSources: 'charts/clearAllSelectedSources',
      selectAndShowNodes: 'charts/selectAndShowNodes',
    }),

    setChart(report) {
      if (!report) return
      const { filter, current } = report;

      //assigning filter
      if(this.split) {
        this.split = filter.split;
      }
      if (filter && filter.sampling) {
        this.sampling = filter.sampling;
      }
      if (filter && filter.fromDate) {
        this.fromDate = moment(filter.fromDate).format("DD/MM/YYYY")
      }
      if (filter && filter.toDate) {
        this.toDate = moment(filter.ToDate).format("DD/MM/YYYY")
      }
      if (filter && filter.fromMonth) {
        this.fromMonth = moment(filter.fromMonth, "M-YYYY")
      }
      if (filter && filter.toMonth) {
        this.toMonth = moment(filter.toMonth, "M-YYYY")
      }
      
      if (filter && filter.compare) {
        this.compare = filter.compare;
      }
 
      if (current)
        this.current = current;

      this.clearAllSelectedSources();
      if (filter && filter.channels) {
        this.channels = [];
        this.selectAndShowNodes(filter.channels)
        // filter.channels.forEach((code) => this.toggleSelectState(this.getNodeByCode(code)));
        this.channels = [...filter.channels];
      }
      if (filter && filter.parameters) {
        this.parameters = [];
        this.selectAndShowNodes(filter.parameters)
        // filter.parameters.forEach((code) => this.toggleSelectState(this.getNodeByCode(code)));
        this.parameters = [...filter.parameters];
      }
    },

    checkSampling() {
      let minSampling = this.getStoreMinSampling();
      
      if(this.current == "slots") {
        if(minSampling != "m" && minSampling != "y") {
          minSampling = "d";
        }
      }

      const disabledSampling = getDisabledByMin(minSampling);
      this.samplingValues = this.samplingValues.map((sampling) => {
        if (disabledSampling.includes(sampling.value)) {
          return {
            ...sampling,
            disabled: false,
          }
        }

        return sampling;
      });

      if (getMinSampling([this.sampling, minSampling]) !== this.sampling) {
        this.sampling = minSampling;
      }
    },

    resetNeedingUpdate() {
      this.isNeedUpdate = false;
    },

    onAggregateModeChanged(aggregateModeEnabled) {
      this.showCompareSelector = !aggregateModeEnabled;
      if (aggregateModeEnabled) {
        this.compare = 'no';
      }
    },

    getDateFormatFromDateString(date) {
      const regexDateLong = new RegExp(/^\d{2}\/\d{2}\/\d{4}$/);
      return regexDateLong.test(date) ? LONG_DATE_FORMAT : SHORT_DATE_FORMAT;
    },

    isDateDisabled(date) {
      const momentDate = moment(date);

      // Is a week and it's not a monday
      if (this.sampling === 'w' && momentDate.weekday() !== 0) {
        return true;
      }

      const currentDate = new Date();
      return date > currentDate;
    },

    setImageURI(uri) {
      this.imageUri = uri;
    },

    setCurrent(type) {
      this.current = type;
      
      this.checkSampling();
    },

    parameterName(code) {
      let parameter = null;
      let siteName = "";
      this.$store.state.user.sites.forEach(site => {
        site.parameters.forEach(c => {
          if (c.code == code) {
            parameter = c.name;
            siteName = site.name;
          }
        });
      });
      return parameter + (this.$store.state.user.sites.length > 1 ? " " + siteName : "");
    },

    fillSelectedChannels(items) {
      if (items && items.length) {
        this.channels = this.channels.concat(items.filter(i => i.selected).map(i => i.code));
        items.forEach(i => this.fillSelectedChannels(i.children));
      }
    },
    isFutureDate(date) {
      const currentDate = new Date();
      return date > currentDate;
    },
    isWeekAndIsNotMonday(date) {
      return this.sampling == "w" && moment(date).day() != 1;
    },
    buttonVariant(code) {
      return code == this.current ? 'secondary' : 'primary';
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Charts/PageMixin.js